import React from 'react';
import {
        HeaderModule, 
        AlertBlock, 
        AlertImg, 
        AlertNumber, 
        InputSearchHeader, 
        ContentAligare,
        LogoAligare,
        ProductName
      } from './styles';

import { numberProcessError } from '../../mockData';

const HeaderModuleComponent = () => (
 <HeaderModule>
  { /* <AlertBlock>
     <AlertImg src="/images/notification.svg" />
     <AlertNumber>
       {numberProcessError}
     </AlertNumber> 
  </AlertBlock>
  <InputSearchHeader
   placeholder="Ingresa una búsqueda"
  /> */ }
  <ContentAligare>
    <LogoAligare src="/images/logo-aligare.png" />
    <ProductName>
    Motor Transaccional Digital
    </ProductName>
  </ContentAligare>
 </HeaderModule>
);

export default HeaderModuleComponent;